import { useQuery } from '@tanstack/react-query';
import { reportBuilderApi } from '../api/reportBuilderApi';

/**
 * GET /api/eraf/report-builder/reports/{id}/preview — 상위 N행 미리보기
 * queryKey: ['report-builder', 'preview', id, rows]
 */
export function useReportPreview(id: number | null, rows = 50, enabled = true) {
  return useQuery({
    queryKey: ['report-builder', 'preview', id, rows],
    queryFn: () => reportBuilderApi.preview(id!, rows),
    enabled: id !== null && enabled,
    staleTime: 60_000,
  });
}
